import React, { useEffect, useState } from 'react';
import {
  DisplayText,
  RadioButton,
  TextStyle,
  Tippy
} from '@superops/ui-design-system';
import { getCellValue } from '@nile/reports/src/modules/EfficiencyReport/util';
import { isEmpty } from 'lodash';
import { getTranslatedText } from '@nile/components';
import { useIntl } from 'react-intl';

// THIS COMPONENT IS USED TO RENDER
// CUSTOM FIELD - RADIO

const CustomRadioField = (props) => {
  const { field, value, onChange, isDisabled, ticket, fields } = props;
  const { fieldType, label } = field;

  const intl = useIntl();
  const [currentValue, setCurrentValue] = useState(value);

  const dataTocheck = { ...ticket, ...ticket?.customFields, ...fields };
  const parentValue =
    getCellValue(dataTocheck, field?.parentField?.columnName) || null;

  const currentValueByRef = React.useRef(null);
  currentValueByRef.current = currentValue;

  const getOptions = () => {
    let fldOptions = field?.options || field?.fieldOptions;
    if (!isEmpty(field?.parentField)) {
      const prntValue =
        typeof parentValue === 'object'
          ? parentValue?.name || parentValue?.id
          : parentValue;
      if (prntValue) {
        fldOptions = fldOptions?.filter(
          (el) => el?.parentOption?.value === prntValue
        );
      } else {
        fldOptions = [];
      }
    }

    const opts = fldOptions?.map((option) => ({
      value: option?.value,
      label: option?.value
    }));
    return opts;
  };

  const options = getOptions();

  const updateValue = (val) => {
    setCurrentValue(val?.label);
    if (onChange && typeof onChange === 'function') {
      onChange(field, val);
    }
  };

  useEffect(() => {
    if (field?.parentField) {
      setCurrentValue(null);
    }
  }, [parentValue]);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  //   Value should be sent by the user
  //   We get fields from the get fields API but the selected values wont be availabe
  //   Selected values should an array of strings ['Choice 1'] and this will be passed to checked prop

  return (
    <>
      <div className="fields-wrapper">
        <DisplayText size="extraLarge" weight="Medium">
          {label}
        </DisplayText>
        <div className="custom-field-input">
          {isEmpty(options) ? (
            <Tippy
              title={
                field?.parentField?.columnName
                  ? `${getTranslatedText(intl, 'common.admin.dependent.to')} ${
                      field?.parentField?.label
                    }`
                  : undefined
              }
              position="bottom-end"
              delay={500}
            >
              <div className="mb10">
                <RadioButton
                  label={getTranslatedText(
                    intl,
                    'common.admin.depedant.field.choose.parent'
                  )}
                  disabled
                />
              </div>
            </Tippy>
          ) : (
            <>
              {options?.map((option, idx) => {
                return (
                  <div className="mb10" key={idx}>
                    <RadioButton
                      checked={currentValueByRef.current === option?.label}
                      label={option?.label}
                      onChange={(val) =>
                        updateValue({ label: option?.label, value: val })
                      }
                      disabled={isDisabled}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomRadioField;
